import { DynamicDropdown } from "src/Components";
import { ICustomerReportScopeSearchParams } from "src/Interfaces/reportLinks";
import { getUsers } from "src/Requests/imePortfolio";

interface IProps {
  searchParam: ICustomerReportScopeSearchParams;
  onChange: (name: string, value: any) => void;
}

const SearchParamBox = ({ searchParam, onChange }: IProps) => {
  return (
    <div className="w-48">
      <DynamicDropdown
        dropdown={{
          name: "accountId",
          placeholder: "اکانت",
          extraLabel: true,
        }}
        value={searchParam.accountId?.toString() ?? ""}
        getData={() => getUsers()}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchParamBox;
